import type { GetQuotationrequestRSDef } from "../../../api/quotation/types";
import { brand } from "../../../context";
import { StatusTag, ViewOfferButton, ViewQuotationChatButton } from "./components";

type QuotationRequestMobileTableProps = {
  quotations: GetQuotationrequestRSDef[];
};

export function QuotationRequestMobileTable({ quotations }: QuotationRequestMobileTableProps) {
  return (
    <table className="Table Quotations__body__mobiletable" data-brand={brand}>
      <thead>
        <tr>
          <th className="text-left!">Reference</th>
          <th className="text-left!">Title</th>
          <th className="text-left!">Status</th>
        </tr>
      </thead>
      <tbody>
        {quotations.map((q, idx) => {
          return (
            <tr key={`${idx}-${q.reference}`} className="odd:bg-gray-100">
              <td className="text-xs text-left!">{q?.reference}</td>
              <td className="text-xs text-left!">{q?.title || "N/A"}</td>
              <td className="text-xs text-left!">
                <div className="flex flex-col gap-1">
                  {q.chat_session_uid && (
                    <ViewQuotationChatButton chatSessionUid={q.chat_session_uid} />
                  )}
                  {!!q?.offer_sent_date && q.offer_reference ? (
                    <ViewOfferButton offerReference={q.offer_reference} />
                  ) : (
                    <StatusTag
                      offerStatus={q.offer_status}
                      status={q.status}
                      statusDisplay={q.status_display}
                    />
                  )}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
